// @flow
/* eslint-disable */

import React, { memo } from 'react';
import Url from 'url-parse';
import Styles from './styles';
import defaultBG from './assets/default.png';
import upBG from './assets/up.png';
import rightBG from './assets/right.png';
import leftBG from './assets/left.png';
import downBG from './assets/down.png';
import okBG from './assets/Ok.png';

type Props = {
  onLeft : () => void,
  onRight : () => void,
  onUp : () => void,
  onDown : () => void,
  onOk : () => void,
};

export default memo(({
  onLeft,
  onRight,
  onUp,
  onDown,
  onOk,
} : Props) => {
  const { pathname } = Url();
  const urlPath = pathname.split('/')[1];
  
  return (
    <Styles
      style={{ display: (urlPath === 'v') ? 'none' : 'block' }}
      backgroundImage={defaultBG}
      upBackgroundImage={upBG}
      rightBackgroundImage={rightBG}
      leftBackgroundImage={leftBG}
      downBackgroundImage={downBG}
      okBackgroundImage={okBG}
    >
      <a className="up" onClick={onUp} />
      <a className="right" onClick={onRight} />
      <a className="down" onClick={onDown} />
      <a className="left" onClick={onLeft} />
      <a className="ok" onClick={onOk} />
    </Styles>
  );
});
